<template>
  <div class="developPage">
    <span>网页正在建设中...</span>
  </div>
</template>

<script>
export default {
  metaInfo: { title: "敬请期待 - 个人中心" },
  name: "developPage",
};
</script>

<style lang="less" scoped>
.developPage {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
}
</style>